const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 61.249 49.905 c 0.247 0.067 0.503 0.109 0.764 0.109 c 0.32 0 0.645 -0.053 0.964 -0.164 c 14.436 -5.022 24.518 -22.287 24.518 -41.986 c 0 -1.621 -1.314 -2.935 -2.935 -2.935 H 73.496 c 0.041 -1.307 0.07 -2.622 0.07 -3.95 c 0 -0.54 -0.438 -0.978 -0.978 -0.978 H 17.414 c -0.54 0 -0.978 0.438 -0.978 0.978 c 0 1.329 0.029 2.643 0.07 3.95 H 5.44 c -1.621 0 -2.935 1.314 -2.935 2.935 c 0 19.7 10.083 36.966 24.52 41.987 c 0.319 0.112 0.644 0.164 0.964 0.164 c 0.261 0 0.516 -0.042 0.763 -0.109 c 2.756 3.988 5.86 6.998 9.2 8.771 v 15.639 h -2.933 c -3.968 0 -7.197 3.228 -7.197 7.197 v 2.618 h -3.245 c -1.621 0 -2.935 1.314 -2.935 2.935 c 0 1.621 1.314 2.935 2.935 2.935 h 40.846 c 1.621 0 2.935 -1.314 2.935 -2.935 c 0 -1.621 -1.314 -2.935 -2.935 -2.935 h -3.245 v -2.618 c 0 -3.968 -3.228 -7.197 -7.197 -7.197 h -2.934 V 58.677 C 55.388 56.903 58.493 53.893 61.249 49.905 z M 81.543 10.798 C 80.771 24.544 74.61 36.469 65.64 42.073 c 3.874 -8.448 6.569 -19.254 7.53 -31.275 H 81.543 z M 8.457 10.798 h 8.373 c 0.962 12.021 3.657 22.828 7.531 31.276 C 15.39 36.47 9.229 24.545 8.457 10.798 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,193,39)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupIcon);
export default __webpack_public_path__ + "static/media/cup-icon.25c32a639df842d852fe013de50d1e10.svg";
export { ForwardRef as ReactComponent };